$(() => {
  const usMapElement = document.querySelector("#usmapbase svg");
  //Check map element
  if (usMapElement) {
    let className;
    //mouseover function trigger
    usMapElement.addEventListener("mouseover", (e) => {
      className = e.target.classList[0];

      if (className) {
        usMapElement.querySelector("text." + className).style.fill = "white";
      }
    });
    //mouseout function trigger
    usMapElement.addEventListener("mouseout", (e) => {
      className = e.target.classList[0];

      if (className) {
        usMapElement.querySelector("text." + className).style.fill = "black";
      }
    });
  }
});
